export default "__VITE_ASSET__wr2Rmsd2__"